import { MessageCircle } from "lucide-react";
import { Reveal, SectionHead } from "./Shared";
import { waLink } from "@/lib/api";

const STEPS = [
  { num: "01", title: "Escríbenos por WhatsApp", text: "Cuéntanos qué electrodoméstico buscas." },
  { num: "02", title: "Conoce los planes vigentes", text: "Nuestro equipo te explica las opciones de financiamiento disponibles." },
  { num: "03", title: "Estrena en tu hogar", text: "Llévate tu electrodoméstico con garantía por escrito." },
];

export default function Financing({ settings }) {
  return (
    <section id="financiamiento" data-testid="financing-section" className="bg-primary py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <SectionHead
          num="04"
          dark
          testid="financing-title"
          title="Compra hoy, paga cómodamente"
          sub="Opciones de financiamiento disponibles. Consulta con nuestro equipo para conocer los planes vigentes."
        />
        <div className="grid grid-cols-1 gap-px border border-white/15 bg-white/15 md:grid-cols-3" data-testid="financing-steps">
          {STEPS.map((s, i) => (
            <Reveal key={s.num} delay={i * 0.1} className="bg-primary p-8 md:p-10">
              <span className="text-5xl font-extrabold leading-none text-white/15 md:text-6xl">{s.num}</span>
              <h3 className="mt-5 text-xl font-extrabold tracking-tight text-white">{s.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-white/70">{s.text}</p>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2} className="mt-12">
          <a
            data-testid="financing-whatsapp-cta"
            href={waLink(settings, "Hola Electrodomésticos Rivera, quiero consultar las opciones de financiamiento.")}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex h-14 items-center justify-center gap-2 rounded-full bg-whatsapp px-8 text-base font-semibold text-white transition-transform duration-300 hover:-translate-y-0.5"
          >
            <MessageCircle className="h-5 w-5" /> Consultar Financiamiento
          </a>
        </Reveal>
      </div>
    </section>
  );
}
